module.exports = __webpack_public_path__ + "media/images/navbar-logo-936e289718d903b0f9f445be5a779568.webp";